// Bulk writes to families/{code}/data/gifts. Each runs in a transaction so two people saving at once
// (or an Undo racing another edit) can't overwrite each other's changes to the same member's list.
import { doc, runTransaction } from 'firebase/firestore';

const giftsRef = (db, code) => doc(db, 'families', code, 'data', 'gifts');

// Numeric ids like the rest of the app (Date.now()), made unique within one batch.
export function newGiftIds(count, now = Date.now()) {
  return Array.from({ length: count }, (_, i) => now * 1000 + i);
}

async function updateMemberList(db, code, person, change) {
  const ref = giftsRef(db, code);
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    const current = (snap.exists() && snap.data().gifts && snap.data().gifts[person]) || [];
    tx.set(ref, { gifts: { [person]: change(current) } }, { merge: true });
  });
}

export function addGiftsBulk(db, code, person, newGifts) {
  return updateMemberList(db, code, person, (list) => [...list, ...newGifts]);
}

export function removeGiftsByIds(db, code, person, ids) {
  const drop = new Set(ids);
  return updateMemberList(db, code, person, (list) => list.filter(g => !drop.has(g.id)));
}
